<!-- 竞猜规则弹窗 游戏币 -->
<template>
<el-dialog
    class="ball-style"
    :visible.sync="status"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    >
    <div class="ball-cup-container">
        <div class="title-text">常胜榜规则</div>
        <div class="tag"><img :src="require('../assets/happy.png')" alt="" height="65"></div>
        <div class="close" @click="closeHandler"><img :src="require('../assets/close.png')" alt="" height="33"></div>
        <div class="rule-cont">
            <div class="rule-item">
                <div class="cont">1、</div>
                <div class="flex-cont">
                    <div class="txt">按照胜利场数进行排行。 </div>
                </div>
            </div>
            <div class="rule-item">
                <div class="cont">2、</div>
                <div class="flex-cont">
                    <div class="txt">胜1场，是指用户按照每场比赛的 “主胜”、“平”、“客胜”结果进行投注，所有的下注次数产生的盈亏，最终累计盈亏净赚金币大于0，即为胜1场。</div>
                </div>
            </div>
            <div class="rule-item">
                <div class="cont">3、</div>
                <div class="flex-cont">
                    <div class="txt">具体如下：</div>
                    <div class="txt">1）同一场比赛，多次对胜利球队下注，本场为1个胜利场 ；</div>
                    <div class="txt">2）同场次中，对“主胜”、“平”、“客胜”均投注，若投注累计盈亏总和小于或等于0，不计为胜利场次排名 ；</div>
                    <div class="txt">3）同场次中，累计盈亏数为0，本场不计为胜利场次 ；</div>
        
                </div>
            </div>
            <div class="rule-item">
                <div class="cont">4、</div>
                <div class="flex-cont">
                    <div class="txt">如胜利场次次数一致，投注次数较少的会员排名靠前。</div>
                </div>
            </div>

        </div>
        

    </div>
    <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
    </span> -->
</el-dialog>
</template>
<script>
export default {
    name :'OftenGoldRules',
    props:['status'],
    data(){
        return {}
    },
    methods:{
        closeHandler(){
            this.$emit('update:status',false)
        }

    }
}
</script>
<style lang="less" scoped>
.ball-style{
    /deep/.el-dialog{width:700px; background: none;}
    /deep/.el-dialog__header{display: none;}
    /deep/.el-dialog__body{
        padding: 0;
    }
}
@media screen and (max-width:768px){
    .ball-style{

        /deep/.el-dialog{width:90%}
    }
}

.ball-cup-container{
    background: url(../assets/dialog-bg.png) no-repeat right top #ff4400; padding:20px 25px; position: relative; border-radius: 10px; background-size: 100%;
    .title-text{font-size: 20px; line-height: 40px; color: #fff; font-weight: 600; margin-bottom: 10px;}
    .tag{position: absolute; right: 75px; top: 5px;}
    .close{position: absolute; right: 25px; top: 15px; cursor: pointer;}
}

.rule-cont{
    padding: 20px; background: #fff; border-radius: 10px; 
    .rule-item{
        display: flex; font-size: 16px; line-height: 30px; color: #353535;
        .li-ico{padding-top: 3px; margin-right: 3px;}
    }
}
@media screen and (max-width:768px) {
    .ball-cup-container{
        padding: 20px 10px;
    }
    .rule-cont{padding: 10px;}
}
</style>